import React, { useState } from 'react';

const Login = ({ onLoginSuccess }) => {
    const [credentials, setCredentials] = useState({
        username: '',
        password: ''
    });

    const handleChange = (e) => {
        setCredentials({
            ...credentials,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (credentials.username === process.env.REACT_APP_AUTH_LOGIN &&
            credentials.password === process.env.REACT_APP_AUTH_PASS) {
            onLoginSuccess();
        }
    };

    return (
        <div style={styles.fullScreen}>
            <div style={styles.loginBox}>
                <h2 style={styles.title}>Login</h2>
                <form onSubmit={handleSubmit} style={styles.form}>
                    <input
                        style={styles.input}
                        type="text"
                        name="username"
                        placeholder="Username"
                        value={credentials.username}
                        onChange={handleChange}
                    />
                    <input
                        style={styles.input}
                        type="password"
                        name="password"
                        placeholder="Password"
                        value={credentials.password}
                        onChange={handleChange}
                    />
                    <button style={styles.button} type="submit">
                        Login
                    </button>
                </form>
            </div>
        </div>
    );
};

const styles = {
    fullScreen: {
        height: '100vh',
        width: '100vw',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#000000'
    },
    loginBox: {
        backgroundColor: '#1a1a1a',
        padding: '40px',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(255, 255, 255, 0.1)',
        width: '300px'
    },
    title: {
        textAlign: 'center',
        marginBottom: '20px',
        color: '#ffffff'
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: '15px'
    },
    input: {
        padding: '12px',
        border: '1px solid #333',
        borderRadius: '4px',
        fontSize: '16px',
        backgroundColor: '#2a2a2a',
        color: '#ffffff'
    },
    button: {
        padding: '12px',
        backgroundColor: '#007bff',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        fontSize: '16px',
        cursor: 'pointer',
        transition: 'background-color 0.2s'
    }
};

export default Login;
